<template>
    <v-card class="mx-1 my-2">      
        <v-card-title>
            <v-flex xs12>
                <h4 class="headline ma-0 grey--text text--darken-2"> {{ fa.name }} </h4>
            </v-flex>
        </v-card-title>
        <v-container grid-list-xs class="px-2">
            <v-layout row wrap>
                <v-flex xs12>
                    <div v-for="adresse in fa.adressen" v-bind:key="adresse.id">
                        <p class="mt-1">
                        {{ adresse.strasse }} <br />
                        {{ adresse.plz }} {{ adresse.ort }}   
                        </p>
                        <v-divider></v-divider>                
                    </div>
                </v-flex>

                <v-flex xs12>
                    <p class="mt-1">
                        <v-icon>phone</v-icon> {{ fa.telefon }}  <br />
                        <v-icon>print</v-icon> {{ fa.fax }} 
                    </p>
                    <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                    <p class="mt-1">
                        <v-icon>mail</v-icon> {{ fa.email }} <br />
                        <v-icon>language</v-icon> {{ fa.web }}                 
                    </p>
                   
                </v-flex>             
            </v-layout>
        </v-container>
        <v-card-actions class="grey darken-3 mt-2 pa-0">
            <v-spacer></v-spacer>
                             
            <v-btn icon v-on:click="gotoEdit(fa.id)">
                <v-icon class="grey--text text--darken-1">build</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon class="grey--text text--darken-1">visibility</v-icon>
            </v-btn>
            <v-btn icon v-on:click="commitDelete">
               <v-icon class="grey--text text--darken-1">delete</v-icon>
            </v-btn>
        </v-card-actions>
        <delete-modal v-bind:showDialog.sync="showDialog" v-on:committed="toDestroy"></delete-modal>
    </v-card>
</template>

<script>
import deleteModal from '../shared/deleteModal.vue'
export default {
    props: [
        'fa'
    ],
    data() {
        return {
            showDialog:false,
            deleteCommited:false
        }
    },
    components: {
        'delete-modal': deleteModal,
    },  
    methods: {
        toDestroy: function(s) {
            this.deleteCommited = s
            if(this.deleteCommited==false) {
                return
            }                
            this.$store.dispatch('setPreFilteredMarken',[])
            this.$store.dispatch('setPreFilteredFirmen',[])
            this.$emit("toDestroy");
        },
        commitDelete: function() {
            this.showDialog=true                       
        },
        gotoEdit: function(id) {
            this.$store.dispatch('setFirma', id).then((response)=>{
                    this.$router.push('/firmen/' + id + '/edit')   
            })
            
        }
    }
    
    
}
    
</script>

<style>
        
    
    
</style>


// WEBPACK FOOTER //
// singleFirmen.vue?548af2f8